import { HStack, Icon, VStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";

export interface ActionNodeProps {
	name: string;
	description: string;
	gyulAmount: number;
	selected?: boolean;
	onEdit?: () => void;
	onDelete?: () => void;
}

export const ActionNode = (p: ActionNodeProps) => {
	const { t } = useTranslation();

	return (
		<VStack
			className={`w-[280px] items-start px-[24px] py-[20px] gap-[6px] rounded-[10px] bg-bg-weak relative ${p.selected ? "outline-ct-weak" : "outline-outline"}`}
		>
			<HStack className="w-full justify-between text-sm font-medium">
				<span className="text-ct-regular">{p.name}</span>
				<HStack className="text-pm-strong">
					<Icon name="GyulLeft" width={18} height={18} />
					<span>{t("common.amountWithCount", { count: p.gyulAmount })}</span>
				</HStack>
			</HStack>
			<span className="text-ct-strong text-lg font-medium">{p.description}</span>
			{p.selected && (
				<HStack className="absolute top-[-20px] right-[50%] translate-x-[50%] gap-[10px] px-[8px] py-[6px] rounded-[10px] bg-bg-weak outline-ct-weak text-ct-weak">
					<button type="button" onPointerDown={(e) => e.stopPropagation()} onClick={p.onEdit}>
						<Icon name="Setting" width={20} height={20} />
					</button>
					<button type="button" onPointerDown={(e) => e.stopPropagation()} onClick={p.onDelete}>
						<Icon name="Trash" width={20} height={20} />
					</button>
				</HStack>
			)}
		</VStack>
	);
};
